/* eslint-disable waimaie/no-direct-access-localstorage */
const storageKey = 'GOD_KNOWS_EVERYTHING';

const God = {
    /** 记录一条日志 */
    see: (eventType: string, data: any) => {
        const record = {
            ts: new Date().getTime(),
            data,
        };

        const store = JSON.parse(localStorage.getItem(storageKey) || '{}');

        if (!Array.isArray(store[eventType])) {
            store[eventType] = [];
        }

        store[eventType].push(record);

        localStorage.setItem(storageKey, JSON.stringify(store));
    },
    /** 提取特定类型日志 */
    recall: (eventType: string) => {
        const store = JSON.parse(localStorage.getItem(storageKey) || '{}');
        return store[eventType] || [];
    },
    /** 移除本地日志，节省空间 */
    forgotEverything: () => {
        localStorage.removeItem(storageKey);
    },
};

export default God;
